import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import { SdkError } from "../errors";

export default async () => {
  const sdkInstance = await sdkInstanceProvider("identity");
  try {
    sdkInstance.login();
  } catch (e) {
    throw new SdkError(e);
  }
};
